import { Button, Typography, Stack } from "@mui/material"

import BaseModal from "@/components/BaseModal/BaseModal"

type ConfirmNavigationDialogProps = {
  open: boolean
  onClose: () => void
  onSecondaryAction: () => void
  onPrimaryAction: () => void
  headingText: string
  bodyText: string
  secondaryButtonText: string
  primaryButtonText: string
}

const ConfirmNavigationDialog = ({
  open,
  onClose,
  onSecondaryAction,
  onPrimaryAction,
  headingText,
  bodyText,
  secondaryButtonText,
  primaryButtonText,
}: ConfirmNavigationDialogProps) => {
  return (
    <BaseModal open={open} onClose={onClose} title={headingText} maxWidth="xs">
      <Typography variant="body2">{bodyText}</Typography>
      <Stack
        direction={{ xs: "column-reverse", sm: "row" }}
        justifyContent="flex-end"
        spacing={2}
        pt={2}
      >
        <Button variant="text" color="primary" onClick={onSecondaryAction}>
          {secondaryButtonText}
        </Button>
        <Button variant="contained" color="primary" onClick={onPrimaryAction}>
          {primaryButtonText}
        </Button>
      </Stack>
    </BaseModal>
  )
}

export default ConfirmNavigationDialog
